<template>
<div>
    <div class="dashboard__title mt-lg-0 d-lg-flex align-items-lg-center">
        <h1 class="title--1 mr-lg-3 mb-lg-0">My Projects</h1>
    </div>

    <article class="dashboard__schedule">
        <ul style="display: flex;">
            <li style="margin-right: 20px;" v-for="(item, index) in projects" :key="index">
                <b>
                    <a :href="`assignment-project-complete/${item.id}`"> {{ item.description }}</a>
                </b>
            </li>
        </ul>
    </article>
</div>
</template>

    
    
<script>
export default {

    components: {
    },

    props: [
        'user'
    ],

    data() {
        return {
            rest_api: 'my_projects',
            projects: [],

        }
    },

    methods: {

        async getAssociateProjects() 
        {
            this.loader(true)

            const response = await this.get(`${this.rest_api}`);

            this.loader()

            if (response.status) 
            {
                this.projects = response.data.projects

            } 
            else 
            {
                this.error_handling(response)
            }
        },
    },

    async mounted() {
        await this.getAssociateProjects()
    }

}
</script>
